module.exports = __webpack_public_path__ + "img/1994.be08aee3.png";